<template>
  <div class="toubu">
    <div class="top">
      <div class="nei">
        <div class="lebox">
          <div class="lewenzi">
            欢迎访问深圳市重大科技基础设施和大型科研仪器共享平台！
          </div>
        </div>
        <div class="ribox">
          <div>
            <img src="../assets/dianhua.png" alt="" />
            <span>86-0755-86725521</span>
          </div>
          <div>
            <img src="../assets/xinfeng.png" alt="" />
            <span>sz-irshare@sticmail.sz.gov.cn</span>
          </div>
          <div v-if="this.token == null">
            <img src="../assets/yonghu.png" alt="" />
            <a @click="tiao(11)">登录</a>
            |
            <a @click="tiao(10)">注册</a>
            &nbsp;&nbsp;
            <!-- <a @click="tiao(9)">个人中心</a> -->
          </div>
          <div v-if="this.token !== null">
            <a @click="tiao(9)">个人中心</a>
            &nbsp;&nbsp;
            <a :href="basePathUrl" target="blank"> 进入管理系统</a>
            &nbsp;&nbsp;
            <a @click="tiao(20)">退出登录</a>
          </div>
        </div>
        <!-- <div class="ribox">
          <div class="riwenzi">
            <div @click="tiao(7)">个人中心</div>
            <img src="../assets/wenxin.png" alt="" />
            <div>官方微信</div>
          </div>
          <div class="riwenzi2">
            <a class="bian" href="/login">登录</a>
            <a href="/login">注册</a>
          </div>
        </div> -->
      </div>
    </div>
    <div class="zjian">
      <div class="nei">
        <div class="biao">
          <img src="../assets/logo@2x.png" alt="" />
          <div>
            <span>推动资源共享</span>
            <span>服务科技创新</span>
          </div>
        </div>
        <div class="daohang">
          <div class="kuai" id="1" @click="tiao(1)">首页</div>
          <div class="kuai" id="2" @click="tiao(2)">资讯动态</div>
          <div class="kuai" id="5" @click="tiao(5)">政策法规</div>
          <div class="kuai" id="6" @click="tiao(6)">办事大厅</div>

          <div class="kuai" id="3" @click="tiao(3)">仪器共享</div>
          <div class="kuai" id="8" @click="tiao(8)">重大设施</div>
          <!-- <div class="kuai" id="4" @click="tiao(4)">在线平台</div> -->
          <div class="kuai" id="7" @click="tiao(7)">科技资源</div>
          <div class="kuai" id="12" @click="tiao(12)">关于平台</div>

          <!-- <div class="kuai" id="6" @click="tiao(6)">评价考核</div>
          <div class="kuai" id="7" @click="tiao(7)">查重评议</div>
          <div class="kuai" id="8" @click="tiao(8)">海关监管</div> -->
          <div class="xian"></div>
        </div>
        <div class="search">
          <div
            class="xiala"
            v-if="
              this.num == 1 ||
              this.num == 3 ||
              this.num == 4 ||
              this.num == 6 ||
              this.num == 7 ||
              this.num == 8 ||
              this.num == 9 ||
              this.num == 12
            "
          >
            <el-select v-model="xiala" placeholder="仪器" :key="this.num">
              <el-option label="仪器" value="仪器"></el-option>
              <el-option label="公告" value="公告"></el-option>
              <el-option label="新闻" value="新闻"></el-option>
              <el-option label="政策" value="政策"></el-option>
            </el-select>
          </div>
          <div class="xiala" v-if="this.num == 2">
            <el-select v-model="xiala" placeholder="新闻" :key="this.num">
              <el-option label="仪器" value="仪器"></el-option>
              <el-option label="公告" value="公告"></el-option>
              <el-option label="新闻" value="新闻"></el-option>
              <el-option label="政策" value="政策"></el-option>
            </el-select>
          </div>
          <div class="xiala" v-if="this.num == 0">
            <el-select v-model="xiala" placeholder="公告" :key="this.num">
              <el-option label="仪器" value="仪器"></el-option>
              <el-option label="公告" value="公告"></el-option>
              <el-option label="新闻" value="新闻"></el-option>
              <el-option label="政策" value="政策"></el-option>
            </el-select>
          </div>
          <div class="xiala" v-if="this.num == 5">
            <el-select v-model="xiala" placeholder="政策" :key="this.num">
              <el-option label="仪器" value="仪器"></el-option>
              <el-option label="公告" value="公告"></el-option>
              <el-option label="新闻" value="新闻"></el-option>
              <el-option label="政策" value="政策"></el-option>
            </el-select>
          </div>

          <input
            v-model="tit"
            class="inp"
            type="text"
            name=""
            id=""
            placeholder="输入关键字 "
          />
          <div class="anniu">
            <i @click="search" class="el-input__icon el-icon-search"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="daohang">
      <div class="nei">
        <div class="kuai" id="1" @click="tiao(1)">首页</div>
        <div class="kuai" id="2" @click="tiao(2)">科研仪器</div>
        <div class="kuai" id="3" @click="tiao(3)">新闻资讯</div>
        <div class="kuai" id="4" @click="tiao(4)">政策制度</div>
        <div class="kuai" id="5" @click="tiao(5)">评价考核</div>
        <div class="kuai" id="6" @click="tiao(6)">海关监管</div>
        <div class="xian"></div>
      </div>
    </div> -->
  </div>
</template>

<script>
import router from "@/router";

// @ is an alias to /src
import * as authUtil from "@/store/auth";

export default {
  name: "Top",
  components: {},
  data() {
    return {
      num: "1",
      xiala: "",
      tit: "",
      token: "",
      basePathUrl: "https://irshare.cn/v2_admin",
    };
  },
  mounted() {
    const token = sessionStorage.getItem("token");

    this.token = token;
    // ////console.log(token);
    this.bian();
    //console.log(this.num);
  },
  methods: {
    search() {
      if (this.tit === "") {
        this.$message.warning("请您输入想搜索的内容");
        return; // 如果输入为空，则直接返回，不执行后续操作
      }
      if ((this.num == 2) & (this.xiala == "")) {
        this.xiala = "新闻";
      }
      if ((this.num == 5) & (this.xiala == "")) {
        this.xiala = "政策";
      }
      if ((this.num == 0) & (this.xiala == "")) {
        this.xiala = "公告";
      }
      //console.log(this.xiala);
      if (this.xiala == "" || this.tit !== "") {
        this.$emit("childEvent", this.tit);
        this.$router.push({ name: "yiqiliebiao", params: { tit: this.tit } });
        sessionStorage.setItem("insuranceCode", JSON.stringify(3));
      }

      if (this.xiala == "仪器") {
        this.$emit("childEvent", this.tit);
        this.$router.push({ name: "yiqiliebiao", params: { tit: this.tit } });
        sessionStorage.setItem("insuranceCode", JSON.stringify(3));
      }

      if (this.xiala == "新闻") {
        this.$emit("childEvent", this.tit);
        this.$router.push({ name: "news", params: { tit: this.tit } });
        sessionStorage.setItem("insuranceCode", JSON.stringify(2));
      }
      if (this.xiala == "公告") {
        this.$emit("childEvent", this.tit);
        this.$router.push({ name: "noticelie", params: { tit: this.tit } });
        sessionStorage.setItem("insuranceCode", JSON.stringify(0));
      }
      if (this.xiala == "政策") {
        this.$emit("childEvent", this.tit);
        this.$router.push({ name: "evalist", params: { tit: this.tit } });
        sessionStorage.setItem("insuranceCode", JSON.stringify(5));
      }
      //console.log(this.xiala);
    },
    bian() {
      this.num = JSON.parse(sessionStorage.getItem("insuranceCode"));
      let ann = document.getElementsByClassName("kuai");
      for (var i = 0; i < ann.length; i++) {
        ann[i].style.color = "#333";
      }
      if (this.num != 9) {
        document.getElementById(this.num).style.color = "#2e8ce3";
        document.getElementById(this.num).style.borderBottom =
          " 4px solid #2b6cf5";
        document.getElementById(this.num).style.width = "80px;";
      }
    },
    tiao(index) {
      this.num = index;
      this.num = JSON.parse(this.num);
      // console.log(this.num);
      sessionStorage.setItem("insuranceCode", JSON.stringify(this.num));
      if (index == 0) {
        this.$router.push("/notice");

        document.documentElement.scrollTop = 0;
      }
      if (index == 1) {
        // this.chus = index;
        this.$router.push("/");
        document.documentElement.scrollTop = 0;
      }
      if (index == 2) {
        this.$router.push("/news");
        document.documentElement.scrollTop = 0;
      }
      if (index == 3) {
        this.$router.push("/yiqiliebiao");
        document.documentElement.scrollTop = 0;
      }
      // if (index == 4) {
      //   this.$router.push("/pingtai");
      //   document.documentElement.scrollTop = 0;
      // }
      if (index == 5) {
        this.$router.push("/evalist");
        document.documentElement.scrollTop = 0;
      }
      if (index == 6) {
        this.$router.push("/banshi");
        document.documentElement.scrollTop = 0;
      }

      if (index == 7) {
        this.$router.push("/pingtai");
        //this.$router.push("/fence");
        document.documentElement.scrollTop = 0;
      }
      if (index == 8) {
        this.$router.push("/sheshi");
        document.documentElement.scrollTop = 0;
      }
      if (index == 9) {
        this.$router.push("/personal").then(() => {
          // 重新刷新页面
          location.reload();
        });
        // this.$router.push("/personal");
        document.documentElement.scrollTop = 0;
      }
      if (index == 10) {
        this.$router.push("/login");

        document.documentElement.scrollTop = 0;
      }
      if (index == 11) {
        this.$router.push("/denglu");

        document.documentElement.scrollTop = 0;
      }
      if (index == 12) {
        this.$router.push("/guanyu");

        document.documentElement.scrollTop = 0;
      }
      if (index == 20) {
        this.$confirm("是否退出登录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("retoken");
            sessionStorage.removeItem("id");
            authUtil.removeToken();
            this.$message({
              type: "success",
              message: "退出登录成功!",
            });
            // location.reload();
            this.$router.push("/");
          })
          .catch(() => {});
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// .toubu {
//   // width: 100%;
// }
.top {
  display: flex;
  width: 100%;
  min-width: 1200px;
  height: 50px;
  background: #0049b1;
  .nei {
    position: relative;
    display: flex;
    width: 100%;
    margin: 0 auto;
  }
  .lebox {
    display: flex;

    .lewenzi {
      margin-left: 143px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      line-height: 50px;
    }
    .lewenzi2 {
      margin-left: 22px;
      font-weight: 400;
      font-size: 16px;
      color: #046bad;
      line-height: 28px;
    }
  }
  .ribox {
    display: flex;
    position: absolute;
    right: 149px;

    div {
      margin-left: 25px;
      line-height: 50px;
      color: #ffffff;
      img {
        vertical-align: middle;
        margin-right: 8px;
        width: 25px;
        height: 25px;
      }
      span {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
      }
      a {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        text-decoration: none;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}
.zjian {
  width: 1920px;
  background-image: url("../assets/top.png");
  background-size: 100% 100%;
  box-shadow: 1px 2px 23px 2px rgba(98, 98, 98, 0.13);
  height: 100px;
  .nei {
    position: relative;
    display: flex;
    width: 1200px;
    margin: 0 auto;
  }
  .biao {
    display: flex;
    line-height: 100px;
    img {
      position: absolute;
      left: -220px;
      margin-top: 17px;

      margin-right: 28px;
      width: 62px;
      height: 64px;
    }
    div {
      width: 120px;

      position: absolute;
      top: 20px;
      left: -120px;
      line-height: 27px;
      span {
        font-family: Source-KeynoteartHans;
        font-weight: 400;
        font-size: 20px;
        color: #434343;
      }
      // line-height: 13px;
    }
  }
  .daohang {
    display: flex;
    background: none;
    margin-left: 120px;
    .kuai {
      text-align: center;
      margin-right: 45px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 20px;
      color: #333333;
      line-height: 100px;

      cursor: pointer;
    }
  }
  ::v-deep .search {
    position: absolute;
    right: -210px;
    top: 32px;
    display: flex;

    cursor: pointer;
    .xiala {
      height: 42px;
      line-height: 36px;
      // .el-input {
      //   height: 40px;
      // }
      .el-input__inner {
        border-radius: 6px 0 0 6px;
        width: 80px;
        height: 42px;
        line-height: 42px;
        padding: 0 0 0 10px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        border: 1px solid #333;
      }
      input::placeholder {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        line-height: 42px;
        color: #333333;
        padding-left: 0;
        // color: #000;
      }
    }
    .inp {
      position: relative;
      padding-left: 11px;
      width: 180px;
      height: 40px;
      // border-radius: 6px 0px 0px 6px;
      border: 1px solid #203378;
    }
    input::placeholder {
      top: -2px;
      position: absolute;
      padding: 11px;
      font-weight: 400;
      font-size: 16px;
      color: #999999;
      // line-height: 13px;
    }
    input[type="text"]:focus {
      outline: none;
    }
    .anniu {
      position: relative;
      width: 42px;
      height: 42px;
      background: #203378;
      border-radius: 0px 5px 5px 0px;
      .el-input__icon {
        bottom: 0%;
        left: 20%;
        position: absolute;
        line-height: 40px !important;
        font-size: 24px;
        color: #fff;
        text-align: left;
      }
    }
  }
}
// .daohang {
//   // width: 960px;
//   height: 46px;
//   background: #2e8ce3;
//   .nei {
//     display: flex;
//     width: 1200px;
//     margin: 0 auto;
//   }
//   .kuai {
//     width: 199px;
//     height: 46px;
//     border-left: 1px solid rgba(255, 255, 255, 0.6);
//     font-weight: bold;
//     font-size: 20px;
//     color: #ffffff;
//     line-height: 46px;
//     text-align: center;
//     cursor: pointer;
//   }
//   // .kuai:hover {
//   //   background-color: #ffa904;
//   // }
//   .xian {
//     width: 1px;
//     height: 46px;
//     background-color: rgba(255, 255, 255, 0.6);
//   }
// }
</style>
